import { http } from "@/api";

// #region Request Controllers

/**
 * Solicita as configurações das anomalias.
 * @param {Number} monitoringElementId Id do elemento de monitração do tipo unidade geradora.
 * @returns Objeto com as configurações de anomalias para a unidade geradora.
 */
const Get = function(monitoringElementId)
{
	return http.get(`/AnomalyDetections?monitoringElementId=${monitoringElementId}`);
};

/**
 * Solicita os resultados de uma determinada configuração de anomalia.
 * @param {Object} params Objeto de parâmetros requisitados para fazer a chamada.
 * @returns Array com os resultados de anomalias para a unidade geradora.
 */
const GetResults = function(params)
{
	return http.get(`/AnomalyDetections/
		${params.id}/AnomalyDetectionResults?startDateTime=
		${params.startDateTime}&endDateTime=
		${params.endDateTime}`);
};

/**
 * Solicita os scores do resultado de anomalia.
 * @param {Object} params Objeto de parâmetros requisitados para fazer a chamada.
 * @returns Array com os resultados de scores anomalias para a unidade geradora.
 */
const GetResultScores = function(params)
{
	return http.get(`/AnomalyDetections/
		${params.id}/AnomalyDetectionResultScores?StartDateTime=
		${params.startDateTime}&EndDateTime=
		${params.endDateTime}`,
	{ headers: { DateTimeFormat: params.dateTimeFormat }, });
};

/**
 * Solicita os scores do resultado de anomalia (Tendência).
 * @param {Object} params Objeto de parâmetros requisitados para fazer a chamada.
 * @returns Array com os resultados de scores anomalias para a unidade geradora.
 */
const GetResultScoresTrends = function(params)
{
	return http.get(`/AnomalyDetections/
		${params.id}/AnomalyDetectionResultScoresTrendChart?startDateTime=
		${params.startDateTime}&endDateTime=
		${params.endDateTime}`);
};

export default
{
	Get,
	GetResults,
	GetResultScores,
	GetResultScoresTrends
};

// #endregion